export const state = {
    congregacoes: []
};